import { environment } from '../../environments/environment';
import { DifferentialTileset } from '../models/differential-tileset';
import { Site } from '../models/site';


export class DifferentialTilesetTools {

  static tilesetUrl(site: Site, df: DifferentialTileset): string | undefined {
    if(df.maxDistance) {
      return environment.apiUrl + '/organizations/' + site.organization + '/sites/' + site.id + '/tilesets/compared_pnts/' + df.id + '/tileset.json'
    }
    return undefined;
  }

}
